import { useContext, useEffect} from 'react';
import MasterQuizCard from './MasterQuizCard';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../../auth/AuthContext';

const MasterQuizzes = () => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  useEffect(() => {
    const quizAccess = authContext.getPermissions('quizmaster');
    if (quizAccess.filter((f) => f.access.includes(1)).length === 0) {
      navigate('/');
    }
  }, [authContext, navigate]);

  return (
    <div className="w-full">
      <div className="space-y-4 mt-4">
        <MasterQuizCard />
      </div>
    </div>
  );
};

export default MasterQuizzes;
